import { useState } from "react";
import {
  Autocomplete,
  Box,
  ListItemText,
  TextField,
  Typography,
  FormControl,
  FormHelperText,
  MenuItem,
} from "@mui/material";
import muiCustomStyles from "./styles";

const SingleSelectAutocomplete = (props) => {
  const {
    options,
    onChange,
    value,
    disabled,
    placeholder = "Select",
    onBlur,
    error = false,
    helperText = "",
  } = props;
  const [open, setOpen] = useState(false);

  const selectedOption = options.find((item) => item.value === value) || null;

  const { formControl, autocomplete, menuItem, menuItemText } = muiCustomStyles;

  const handleMenuItemClick = (newValue) => {
    onChange(newValue);
    setOpen(false);
    if (onBlur) {
      onBlur({ target: { value: newValue } });
    }
  };

  return (
    <FormControl error={error} sx={formControl}>
      <Autocomplete
        disablePortal
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        disabled={disabled}
        options={options}
        getOptionLabel={(option) => option.label}
        value={selectedOption}
        sx={autocomplete}
        renderInput={(params) => (
          <TextField
            {...params}
            error={error}
            placeholder={selectedOption ? "" : placeholder}
            onBlur={onBlur}
            sx={{
              "& .MuiInputBase-input": {
                p: "0px !important",
                border: "none !important",
              },
            }}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <img src="/icons/arrow-down.svg" alt="arrow-down" />
                </Box>
              ),
            }}
          />
        )}
        renderOption={(props, option, state) => {
          return (
            <MenuItem
              key={option.value}
              onClick={() => handleMenuItemClick(option.value)}
              selected={value === option.value}
              sx={{
                ...menuItem,
                mb: state.index !== options.length - 1 ? "12px" : 0,
              }}
            >
              <ListItemText
                primary={
                  <Typography sx={{ ...menuItemText }}>
                    {option.label}
                  </Typography>
                }
              />
            </MenuItem>
          );
        }}
      />
      {helperText && (
        <FormHelperText sx={{ mt: "4px", ml: "0px", fontSize: "13px" }}>
          {helperText}
        </FormHelperText>
      )}
    </FormControl>
  );
};

export default SingleSelectAutocomplete;
